<svg
	width="100%"
	height="100%"
	viewBox="0 0 67 67"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	xml:space="preserve"
	stroke="currentColor"
	stroke-width="1"
	stroke-linecap="round"
	stroke-linejoin="round"
>
	<g transform="matrix(5.55556,0,0,5.55556,0,0)">
		<g>
			<path d="M6,8L6,6M6,4L6.005,4" />
		</g>
	</g>
</svg>
